import React from 'react'
import classnames from 'classnames'
import { IsViewport } from '@zambezi/layout-grid'
import { followStoreLink$ } from '../navigation'
import format from '@apiEnabler/ob-common/lib/currency-formatter'
import { formatDate } from '@apiEnabler/ob-common/lib/date-utils'
import { getStatusName } from '@apiEnabler/ob-common/lib/standing-order-consents'

import Avatar from './Avatar'
import StatusIcon from './StatusIcon'
import style from './StandingOrderCard.module.css'

export default function StandingOrderCard({ standingOrder, className }) {
  return (
    <button
      className={classnames(className, style.activeCard, 'legacyCard')}
      onClick={() =>
        followStoreLink$.next(
          `/recurring-payments/standing-orders/${standingOrder.get('id')}`
        )
      }
    >
      <div className={style.content}>
        <IsViewport isTablet isDesktop isWidescreen>
          <Avatar
            content={standingOrder.getIn([
              'payload',
              'creditor',
              'account',
              'customerName',
            ])}
            className={`${style.avatar}`}
          />
        </IsViewport>
        <span className={`${style.clientName} js-client-name`}>
          {standingOrder.getIn([
            'payload',
            'creditor',
            'account',
            'customerName',
          ])}
        </span>
        <PaymentInformation standingOrder={standingOrder} />
        <StatusIcon
          status={getStatusName(standingOrder)}
          className={style.statusIcon}
        />
        <span className={`${style.amount} js-standing-order-amount`}>
          {format(
            standingOrder.getIn(['payload', 'currency']),
            standingOrder.getIn(['payload', 'nextPaymentAmount'])
          )}
        </span>
      </div>
    </button>
  )
}

export function EmptyStandingOrderCard() {
  return (
    <div className={classnames('js-standing-order-empty', style.card)}>
      <div className={style.content}>
        <IsViewport isTablet isDesktop isWidescreen>
          <Avatar className={style.hiddenAvatar} />
        </IsViewport>
        <span className={`${style.emptyMessage} js-message`}>
          You have no third parties
        </span>
      </div>
    </div>
  )
}

function PaymentInformation({ standingOrder }) {
  const date = standingOrder.getIn(['payload', 'paymentDate'])
  const label = standingOrder.getIn(['payload', 'paymentLabel'])
  return (
    <div className={`${style.information} js-standing-order-information`}>
      {standingOrder.getIn(['payload', 'displayFrequency'])}
      {` payment ${label} at `}
      <time className={style.date}>{formatDate(date)}</time>
    </div>
  )
}
